type DoryLocalForageDriver = LocalForageDriver & {
  _storage: Record<string, unknown>;
};

/**
 * Fallback localforage driver if no other driver is available, this loses the stored information on page reload
 */
export const JsDriver: DoryLocalForageDriver = {
  _driver: 'DoryJsDriver',
  _storage: {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  _initStorage(): void {},
  clear(callback) {
    this._storage = {};
    if (callback) callback(undefined);
    return Promise.resolve();
  },
  getItem(key, callback) {
    const item = this._storage[key];
    if (callback) callback(undefined, item ?? null);
    return Promise.resolve(item ?? null);
  },
  iterate(iteratorCallback, successCallback) {
    Object.keys(this._storage).forEach((key, index) => {
      if (iteratorCallback) iteratorCallback(this._storage[key], key, index + 1);
    });
    if (successCallback) successCallback(undefined, undefined);
    return Promise.resolve(undefined);
  },
  key(keyIndex, callback) {
    const keys = Object.keys(this._storage);
    const exists = keys[keyIndex] !== undefined;
    if (exists) {
      if (callback) callback(undefined, keys[keyIndex]);
      return Promise.resolve(keys[keyIndex]);
    } else {
      if (callback) callback(undefined, null);
      return Promise.resolve(null);
    }
  },
  keys(callback) {
    const keys = Object.keys(this._storage);
    if (callback) callback(undefined, keys);
    return Promise.resolve(keys);
  },
  length(callback) {
    const length = Object.keys(this._storage).length;
    if (callback) callback(undefined, length);
    return Promise.resolve(length);
  },
  removeItem(key, callback) {
    const exists = this._storage[key] !== undefined;
    if (exists) {
      delete this._storage[key];
      if (callback) callback(undefined);
      return Promise.resolve();
    } else {
      if (callback) callback(undefined);
      return Promise.resolve(null);
    }
  },
  setItem(key, value, callback) {
    this._storage[key] = value;
    if (callback) callback(undefined, value);
    return Promise.resolve(value);
  },
};
